/* Retired compatibility path. All approved flag mappings now come from gameday-flag-perimeters.js. */
window.EXOGamedayFlagGeometry = window.EXOGamedayFlagPerimeters?.perimeters || Object.freeze({});
